import { useMutation } from 'react-query';
import { submitPersonnelAdjustment } from 'apis/personnelAdjustment.api';

const useSubmitPersonnelAdjustment = () => {
  const { mutateAsync, ...rest } = useMutation(submitPersonnelAdjustment);

  return {
    mutateAsync,
    ...rest,
  };
};

export default useSubmitPersonnelAdjustment;
